import { useContext, useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { UserPermissionContext } from "../context/UserPermissionProvider";

import Cookies from "js-cookie";
import NavigationBar from "./Navigation/NavigationBar";
import PageBar from "./content/PageBar";
import HomePage from "./content/PageContent/HomePage";

import { Sidebar } from "primereact/sidebar";
import { OrgInfoContext } from "../context/OrgInfoProvider";

import Authorization from "./Authorization/Authorization";
//Dashboards
import DashBoards from "./content/PageContent/DashBoards/DashBoards";
// Products and services
import Products from "./content/PageContent/ProductsAndServices/Products";
import ProductCreation from "./content/PageContent/ProductsAndServices/ProductCreation";
import Services from "./content/PageContent/ProductsAndServices/Services";
import ServiceCreation from "./content/PageContent/ProductsAndServices/ServiceCreation";
//Accounting
import ProductsReception from "./content/PageContent/Accounting/ProductsReception";
import NewProductsReception from "./content/PageContent/Accounting/NewProductsReception";
import ProductsTransfer from "./content/PageContent/Accounting/ProductsTransfer";
import ProductsTransferDetails from "./content/PageContent/Accounting/ProductsTransferDetails";
import DistributorReturns from "./content/PageContent/Accounting/DistributorReturns";
import DistributorReturnDetails from "./content/PageContent/Accounting/DistributorReturnDetails";
import LeftOvers from "./content/PageContent/Accounting/LeftOvers";
import ExternalProducts from "./content/PageContent/Accounting/ExternalProducts";
import ExternalProductDetails from "./content/PageContent/Accounting/ExternalProductDetails";
import Writeoffs from "./content/PageContent/Accounting/Writeoffs";
import NewWriteOff from "./content/PageContent/Accounting/NewWriteOff";
//Product sales
import Orders from "./content/PageContent/Sales/Orders";
import OrderDetails from "./content/PageContent/Sales/OrderDetails";
import Sales from "./content/PageContent/Sales/Sales";
import NewSale from "./content/PageContent/Sales/NewSale";
import ProductsReturn from "./content/PageContent/Sales/ProductsReturn";
import NewProductsReturn from "./content/PageContent/Sales/NewProductsReturn";
import ExternalActs from "./content/PageContent/Sales/ExternalActs";
import ExternalActDetails from "./content/PageContent/Sales/ExternalActDetails";
//CounterAgents 
import Partners from "./content/PageContent/CounterAgents/Partners";
import Clients from "./content/PageContent/CounterAgents/Clients";
import NewCounterAgent from "./content/PageContent/CounterAgents/NewCounterAgent";
//Bookkeeping
import Transactions from "./content/PageContent/BookKeeping/Transactions";
import Payments from "./content/PageContent/BookKeeping/Payments";
import Settlements from "./content/PageContent/BookKeeping/Settlements";
//Analytics 
import Reports from "./content/PageContent/Analytics/Reports";
//Settings
import Organization from "./content/PageContent/Settings/Organization";
import Users from "./content/PageContent/Settings/Users";
import NewUser from "./content/PageContent/Settings/NewUser";
import UserRoles from "./content/PageContent/Settings/UserRoles";
import NewUserRole from "./content/PageContent/Settings/NewUserRole";
import Divisions from "./content/PageContent/Settings/Divisions";
import NewDivision from "./content/PageContent/Settings/NewDivision";
import Currencies from "./content/PageContent/Settings/Currencies";
import CurrencyRates from "./content/PageContent/Settings/CurrencyRates";
import DocumentTemplates from "./content/PageContent/Settings/DocumentTemplates";
import MarketPlace from "./content/PageContent/Settings/MarketPlace";
import OlxPlugin from "./content/PageContent/Settings/Plugins/OlxPlugin";
import B2bSkladPlugin from "./content/PageContent/Settings/Plugins/B2bSkladPlugin";

import classes from "./Layout.module.css";
import NewReport from "./content/PageContent/Analytics/NewReport";
import ReportsArchive from "./content/PageContent/Analytics/ReportsArchive";
import { addLocale, locale } from "primereact/api";
import { UaLocale } from "../Utils/TranslationUtils";
import Dictionaries from "./content/PageContent/Settings/Dictionaries";

const Layout = params => {

  const navigate = useNavigate();
  const { loadPermissions, permissions } = useContext(UserPermissionContext);
  const { loadOrgData, orgLogo, darkThemeLogo } = useContext(OrgInfoContext);

  addLocale('ua', UaLocale);
  locale('ua');

  const [isDarkTheme, setIsDarkTheme] = useState(Cookies.get("isDarkTheme") === "true");
  const [navBarVisible, setNavBarVisible] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1180);
  const [visible, setVisible] = useState(false);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1180);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (permissions === null) {
      loadPermissions(Cookies.get("userId"));
    }
  }, [loadPermissions, permissions]);

  useEffect(() => {
    if (orgLogo === null) {
      loadOrgData();
    }
  }, [loadOrgData, orgLogo]);

  useEffect(() => {
    const themeLink = document.getElementById('app-theme');
    const themeName = isDarkTheme ? 'lara-dark-indigo' : 'lara-light-indigo';
    console.log(`${process.env.PUBLIC_URL}/themes/${themeName}/theme.css`);
    themeLink.setAttribute('href', `${process.env.PUBLIC_URL}/themes/${themeName}/theme.css`);
  }, [isDarkTheme])

  const UnloginHandler = () => {
    console.log("unloginned");
    params.onLogoff(false);
  }

  const ChangeBarStateHandler = () => {
    if (isMobile) {
      setVisible(!visible);
    }
    else {
      setNavBarVisible(!navBarVisible);
    }
  }

  const SwitchPagesHandler = () => {
    setVisible(!visible);
  }

  const SwitchThemeHandler = (isDark) => {
    setIsDarkTheme(isDark);
  }

  const mainContentStyle = () => {
    if (isMobile) {
      return "col-12";
    }
    else {
      return navBarVisible ? "col-10" : "col-12"
    }
  }

  return (
    <div className="grid">
      {isMobile && <Sidebar
        visible={visible}
        position="left"
        onHide={() => setVisible(false)}
        content={() => (<>
          <div className="flex align-items-center justify-content-center pt-3">
            <img src={!isDarkTheme ? orgLogo : darkThemeLogo} height="80" alt='iHome' className={classes.logoStyle} onClick={() => navigate("/")} />
          </div>
          <NavigationBar switchPage={SwitchPagesHandler} />
        </>)}
      />}
      {(!isMobile && navBarVisible) && <div className="col-2">
        <div className={classes.companyLogo}>
          <img src={!isDarkTheme ? orgLogo : darkThemeLogo} alt={"IHomeLogo"} width={205} height={125} onClick={() => navigate("/")} />
        </div>
        <NavigationBar switchPage={SwitchPagesHandler} />
      </div>}
      <div className={mainContentStyle()}>
        <PageBar setUnloginned={UnloginHandler} changeNavBarState={ChangeBarStateHandler} switchTheme={SwitchThemeHandler} />
        <Routes>
          <Route exact path="/authorization" element={<Authorization />} />
          <Route exact path="/" element={permissions?.includes("dashboards.view_dashboard") ? <DashBoards isDarkTheme={isDarkTheme} /> : <HomePage />} />
          <Route exact path="/widgets" element={<DashBoards isDarkTheme={isDarkTheme} />} />
          <Route exact path="/products" element={<Products isDarkTheme={isDarkTheme} />} />
          <Route exact path="/products/createproduct" element={<ProductCreation />} />
          <Route exact path="/products/editproduct/:id" element={<ProductCreation />} />
          <Route exact path="/services" element={<Services isDarkTheme={isDarkTheme} />} />
          <Route exact path="/services/createservice" element={<ServiceCreation />} />
          <Route exact path="/services/editservice/:id" element={<ServiceCreation />} />
          <Route exact path="/productsreception" element={<ProductsReception />} />
          <Route exact path="/productsreception/newreception" element={<NewProductsReception />} />
          <Route exact path="/productsreception/editreception/:id" element={<NewProductsReception />} />
          <Route exact path="/productstransfer" element={<ProductsTransfer />} />
          <Route exact path="/productstransfer/productstransferdetails/:id" element={<ProductsTransferDetails />} />
          <Route exact path="/productstransfer/newproductstransfer/" element={<ProductsTransferDetails />} />
          <Route exact path="/leftovers" element={<LeftOvers isDarkTheme={isDarkTheme} />} />
          <Route exact path="/externalproducts" element={<ExternalProducts isDarkTheme={isDarkTheme} />} />
          <Route exact path="/externalproducts/newexternalproduct" element={<ExternalProductDetails />} />
          <Route exact path="/externalproducts/editexternalproduct/:id" element={<ExternalProductDetails />} />
          <Route exact path="/writeoff" element={<Writeoffs />} />
          <Route exact path="/writeoff/newwriteoff" element={<NewWriteOff />} />
          <Route exact path="/writeoff/editwriteoff/:id" element={<NewWriteOff />} />
          <Route exact path="/distributorreturns" element={<DistributorReturns />} />
          <Route exact path="/distributorreturns/newreturn" element={<DistributorReturnDetails />} />
          <Route exact path="/distributorreturns/editreturn/:id" element={<DistributorReturnDetails />} />
          <Route exact path="/productsreturn" element={<ProductsReturn />} />
          <Route exact path="/productsreturn/newproductsreturn" element={<NewProductsReturn />} />
          <Route exact path="/productsreturn/editproductsreturn/:id" element={<NewProductsReturn />} />
          <Route exact path="/orders" element={<Orders />} />
          <Route exact path="/orders/neworder" element={<OrderDetails />} />
          <Route exact path="/orders/editorder/:id" element={<OrderDetails />} />
          <Route exact path="/sales" element={<Sales />} />
          <Route exact path="/sales/newsale" element={<NewSale />} />
          <Route exact path="/sales/editsale/:id" element={<NewSale />} />
          <Route exact path="/externalacts" element={<ExternalActs />} />
          <Route exact path="/externalacts/newexternalact" element={<ExternalActDetails />} />
          <Route exact path="/externalacts/editexternalact/:id" element={<ExternalActDetails />} />
          <Route exact path="/partners" element={<Partners />} />
          <Route exact path="/clients" element={<Clients />} />
          <Route exact path="/partners/newcounteragent" element={<NewCounterAgent />} />
          <Route exact path="/clients/newcounteragent" element={<NewCounterAgent />} />
          <Route exact path="/clients/editcounteragent/:id" element={<NewCounterAgent />} />
          <Route exact path="/partners/editcounteragent/:id" element={<NewCounterAgent />} />
          <Route exact path="/transactions" element={<Transactions />} />
          <Route exact path="/payments" element={<Payments />} />
          <Route exact path="/settlements" element={<Settlements />} />
          <Route exact path="/reports" element={<Reports />} />
          <Route exact path="/reports/reportdetails" element={<NewReport />} />
          <Route exact path="/reportsarchive" element={<ReportsArchive />} />
          <Route exact path="/organizationsettings" element={<Organization isDarkTheme={isDarkTheme} />} />
          <Route exact path="/dictionaries" element={<Dictionaries />} />
          <Route exact path="/users" element={<Users />} />
          <Route exact path="/users/newuser" element={<NewUser />} />
          <Route exact path="/users/edituser/:id" element={<NewUser />} />
          <Route exact path="/roles" element={<UserRoles />} />
          <Route exact path="/roles/newuserrole" element={<NewUserRole />} />
          <Route exact path="/roles/edituserrole/:id" element={<NewUserRole />} />
          <Route exact path="/divisions" element={<Divisions />} />
          <Route exact path="/divisions/newdivision" element={<NewDivision />} />
          <Route exact path="/divisions/editdivision/:id" element={<NewDivision />} />
          <Route exact path="/currencies" element={<Currencies />} />
          <Route exact path="/currencies/currencyrates/:id" element={<CurrencyRates />} />
          <Route exact path="/templates" element={<DocumentTemplates />} />
          <Route exact path="marketplace" element={<MarketPlace/>} />
          <Route exact path="marketplace/OLX_ADVERTS" element={<OlxPlugin />}/>
          <Route exact path="marketplace/B2B_SKLAD_PLUGIN" element={<B2bSkladPlugin />}/>
        </Routes>
      </div>
    </div>
  );
};

export default Layout;